export default [
    {
        "id": 1,
        "name": "Afeganistão",
        "initials2": "AF",
        "initials3": "AFG",
        "code": "004"
    },
    {
        "id": 2,
        "name": "África do Sul",
        "initials2": "ZA",
        "initials3": "ZAF",
        "code": "710"
    },
    {
        "id": 3,
        "name": "Albânia",
        "initials2": "AL",
        "initials3": "ALB",
        "code": "008"
    },
    {
        "id": 4,
        "name": "Alemanha",
        "initials2": "DE",
        "initials3": "DEU",
        "code": "276"
    },
    {
        "id": 5,
        "name": "Andorra",
        "initials2": "AD",
        "initials3": "AND",
        "code": "020"
    },
    {
        "id": 6,
        "name": "Angola",
        "initials2": "AO",
        "initials3": "AGO",
        "code": "024"
    },
    {
        "id": 7,
        "name": "Anguilla",
        "initials2": "AI",
        "initials3": "AIA",
        "code": "660"
    },
    {
        "id": 8,
        "name": "Antártida",
        "initials2": "AQ",
        "initials3": "ATA",
        "code": "010"
    },
    {
        "id": 9,
        "name": "Antígua e Barbuda",
        "initials2": "AG",
        "initials3": "ATG",
        "code": "028"
    },
    {
        "id": 10,
        "name": "Antilhas Holandesas",
        "initials2": "AN",
        "initials3": "ANT",
        "code": "530"
    },
    {
        "id": 11,
        "name": "Arábia Saudita",
        "initials2": "SA",
        "initials3": "SAU",
        "code": "682"
    },
    {
        "id": 12,
        "name": "Argélia",
        "initials2": "DZ",
        "initials3": "DZA",
        "code": "012"
    },
    {
        "id": 13,
        "name": "Argentina",
        "initials2": "AR",
        "initials3": "ARG",
        "code": "032"
    },
    {
        "id": 14,
        "name": "Armênia",
        "initials2": "AM",
        "initials3": "ARM",
        "code": "51"
    },
    {
        "id": 15,
        "name": "Aruba",
        "initials2": "AW",
        "initials3": "ABW",
        "code": "533"
    },
    {
        "id": 16,
        "name": "Austrália",
        "initials2": "AU",
        "initials3": "AUS",
        "code": "036"
    },
    {
        "id": 17,
        "name": "Áustria",
        "initials2": "AT",
        "initials3": "AUT",
        "code": "040"
    },
    {
        "id": 18,
        "name": "Azerbaijão",
        "initials2": "AZ  ",
        "initials3": "AZE",
        "code": "31"
    },
    {
        "id": 19,
        "name": "Bahamas",
        "initials2": "BS",
        "initials3": "BHS",
        "code": "044"
    },
    {
        "id": 20,
        "name": "Bahrein",
        "initials2": "BH",
        "initials3": "BHR",
        "code": "048"
    },
    {
        "id": 21,
        "name": "Bangladesh",
        "initials2": "BD",
        "initials3": "BGD",
        "code": "050"
    },
    {
        "id": 22,
        "name": "Barbados",
        "initials2": "BB",
        "initials3": "BRB",
        "code": "052"
    },
    {
        "id": 23,
        "name": "Belarus",
        "initials2": "BY",
        "initials3": "BLR",
        "code": "112"
    },
    {
        "id": 24,
        "name": "Bélgica",
        "initials2": "BE",
        "initials3": "BEL",
        "code": "056"
    },
    {
        "id": 25,
        "name": "Belize",
        "initials2": "BZ",
        "initials3": "BLZ",
        "code": "084"
    },
    {
        "id": 26,
        "name": "Benin",
        "initials2": "BJ",
        "initials3": "BEN",
        "code": "204"
    },
    {
        "id": 27,
        "name": "Bermudas",
        "initials2": "BM",
        "initials3": "BMU",
        "code": "060"
    },
    {
        "id": 28,
        "name": "Bolívia",
        "initials2": "BO",
        "initials3": "BOL",
        "code": "068"
    },
    {
        "id": 29,
        "name": "Bósnia-Herzegóvina",
        "initials2": "BA",
        "initials3": "BIH",
        "code": "070"
    },
    {
        "id": 30,
        "name": "Botsuana",
        "initials2": "BW",
        "initials3": "BWA",
        "code": "072"
    },
    {
        "id": 31,
        "name": "Brasil",
        "initials2": "BR",
        "initials3": "BRA",
        "code": "076"
    },
    {
        "id": 32,
        "name": "Brunei",
        "initials2": "BN",
        "initials3": "BRN",
        "code": "096"
    },
    {
        "id": 33,
        "name": "Bulgária",
        "initials2": "BG",
        "initials3": "BGR",
        "code": "100"
    },
    {
        "id": 34,
        "name": "Burkina Fasso",
        "initials2": "BF",
        "initials3": "BFA",
        "code": "854"
    },
    {
        "id": 35,
        "name": "Burundi",
        "initials2": "BI",
        "initials3": "BDI",
        "code": "108"
    },
    {
        "id": 36,
        "name": "Butão",
        "initials2": "BT",
        "initials3": "BTN",
        "code": "064"
    },
    {
        "id": 37,
        "name": "Cabo Verde",
        "initials2": "CV",
        "initials3": "CPV",
        "code": "132"
    },
    {
        "id": 38,
        "name": "Camarões",
        "initials2": "CM",
        "initials3": "CMR",
        "code": "120"
    },
    {
        "id": 39,
        "name": "Camboja",
        "initials2": "KH",
        "initials3": "KHM",
        "code": "116"
    },
    {
        "id": 40,
        "name": "Canadá",
        "initials2": "CA",
        "initials3": "CAN",
        "code": "124"
    },
    {
        "id": 41,
        "name": "Cazaquistão",
        "initials2": "KZ",
        "initials3": "KAZ",
        "code": "398"
    },
    {
        "id": 42,
        "name": "Chade",
        "initials2": "TD",
        "initials3": "TCD",
        "code": "148"
    },
    {
        "id": 43,
        "name": "Chile",
        "initials2": "CL",
        "initials3": "CHL",
        "code": "152"
    },
    {
        "id": 44,
        "name": "China",
        "initials2": "CN",
        "initials3": "CHN",
        "code": "156"
    },
    {
        "id": 45,
        "name": "Chipre",
        "initials2": "CY",
        "initials3": "CYP",
        "code": "196"
    },
    {
        "id": 46,
        "name": "Cingapura",
        "initials2": "SG",
        "initials3": "SGP",
        "code": "702"
    },
    {
        "id": 47,
        "name": "Colômbia",
        "initials2": "CO",
        "initials3": "COL",
        "code": "170"
    },
    {
        "id": 48,
        "name": "Congo",
        "initials2": "CG",
        "initials3": "COG",
        "code": "178"
    },
    {
        "id": 49,
        "name": "Coréia do Norte",
        "initials2": "KP",
        "initials3": "PRK",
        "code": "408"
    },
    {
        "id": 50,
        "name": "Coréia do Sul",
        "initials2": "KR",
        "initials3": "KOR",
        "code": "410"
    },
    {
        "id": 51,
        "name": "Costa do Marfim",
        "initials2": "CI",
        "initials3": "CIV",
        "code": "384"
    },
    {
        "id": 52,
        "name": "Costa Rica",
        "initials2": "CR",
        "initials3": "CRI",
        "code": "188"
    },
    {
        "id": 53,
        "name": "Croácia (Hrvatska)",
        "initials2": "HR",
        "initials3": "HRV",
        "code": "191"
    },
    {
        "id": 54,
        "name": "Cuba",
        "initials2": "CU",
        "initials3": "CUB",
        "code": "192"
    },
    {
        "id": 55,
        "name": "Dinamarca",
        "initials2": "DK",
        "initials3": "DNK",
        "code": "208"
    },
    {
        "id": 56,
        "name": "Djibuti",
        "initials2": "DJ",
        "initials3": "DJI",
        "code": "262"
    },
    {
        "id": 57,
        "name": "Dominica",
        "initials2": "DM",
        "initials3": "DMA",
        "code": "212"
    },
    {
        "id": 58,
        "name": "Egito",
        "initials2": "EG",
        "initials3": "EGY",
        "code": "818"
    },
    {
        "id": 59,
        "name": "El Salvador",
        "initials2": "SV",
        "initials3": "SLV",
        "code": "222"
    },
    {
        "id": 60,
        "name": "Emirados Árabes Unidos",
        "initials2": "AE",
        "initials3": "ARE",
        "code": "784"
    },
    {
        "id": 61,
        "name": "Equador",
        "initials2": "EC",
        "initials3": "ECU",
        "code": "218"
    },
    {
        "id": 62,
        "name": "Eritréia",
        "initials2": "ER",
        "initials3": "ERI",
        "code": "232"
    },
    {
        "id": 63,
        "name": "Eslováquia",
        "initials2": "SK",
        "initials3": "SVK",
        "code": "703"
    },
    {
        "id": 64,
        "name": "Eslovênia",
        "initials2": "SI",
        "initials3": "SVN",
        "code": "705"
    },
    {
        "id": 65,
        "name": "Espanha",
        "initials2": "ES",
        "initials3": "ESP",
        "code": "724"
    },
    {
        "id": 66,
        "name": "Estados Unidos",
        "initials2": "US",
        "initials3": "USA",
        "code": "840"
    },
    {
        "id": 67,
        "name": "Estônia",
        "initials2": "EE",
        "initials3": "EST",
        "code": "233"
    },
    {
        "id": 68,
        "name": "Etiópia",
        "initials2": "ET",
        "initials3": "ETH",
        "code": "231"
    },
    {
        "id": 69,
        "name": "Fiji",
        "initials2": "FJ",
        "initials3": "FJI",
        "code": "242"
    },
    {
        "id": 70,
        "name": "Filipinas",
        "initials2": "PH",
        "initials3": "PHL",
        "code": "608"
    },
    {
        "id": 71,
        "name": "Finlândia",
        "initials2": "FI",
        "initials3": "FIN",
        "code": "246"
    },
    {
        "id": 72,
        "name": "França",
        "initials2": "FR",
        "initials3": "FRA",
        "code": "250"
    },
    {
        "id": 73,
        "name": "Gabão",
        "initials2": "GA",
        "initials3": "GAB",
        "code": "266"
    },
    {
        "id": 74,
        "name": "Gâmbia",
        "initials2": "GM",
        "initials3": "GMB",
        "code": "270"
    },
    {
        "id": 75,
        "name": "Gana",
        "initials2": "GH",
        "initials3": "GHA",
        "code": "288"
    },
    {
        "id": 76,
        "name": "Geórgia",
        "initials2": "GE",
        "initials3": "GEO",
        "code": "268"
    },
    {
        "id": 77,
        "name": "Gibraltar",
        "initials2": "GI",
        "initials3": "GIB",
        "code": "292"
    },
    {
        "id": 78,
        "name": "Grã-Bretanha (Reino Unido, UK)",
        "initials2": "GB",
        "initials3": "GBR",
        "code": "826"
    },
    {
        "id": 79,
        "name": "Granada",
        "initials2": "GD",
        "initials3": "GRD",
        "code": "308"
    },
    {
        "id": 80,
        "name": "Grécia",
        "initials2": "GR",
        "initials3": "GRC",
        "code": "300"
    },
    {
        "id": 81,
        "name": "Groelândia",
        "initials2": "GL",
        "initials3": "GRL",
        "code": "304"
    },
    {
        "id": 82,
        "name": "Guadalupe",
        "initials2": "GP",
        "initials3": "GLP",
        "code": "312"
    },
    {
        "id": 83,
        "name": "Guam (Território dos Estados Unidos)",
        "initials2": "GU",
        "initials3": "GUM",
        "code": "316"
    },
    {
        "id": 84,
        "name": "Guatemala",
        "initials2": "GT",
        "initials3": "GTM",
        "code": "320"
    },
    {
        "id": 85,
        "name": "Guernsey",
        "initials2": "G",
        "initials3": "GGY",
        "code": "832"
    },
    {
        "id": 86,
        "name": "Guiana",
        "initials2": "GY",
        "initials3": "GUY",
        "code": "328"
    },
    {
        "id": 87,
        "name": "Guiana Francesa",
        "initials2": "GF",
        "initials3": "GUF",
        "code": "254"
    },
    {
        "id": 88,
        "name": "Guiné",
        "initials2": "GN",
        "initials3": "GIN",
        "code": "324"
    },
    {
        "id": 89,
        "name": "Guiné Equatorial",
        "initials2": "GQ",
        "initials3": "GNQ",
        "code": "226"
    },
    {
        "id": 90,
        "name": "Guiné-Bissau",
        "initials2": "GW",
        "initials3": "GNB",
        "code": "624"
    },
    {
        "id": 91,
        "name": "Haiti",
        "initials2": "HT",
        "initials3": "HTI",
        "code": "332"
    },
    {
        "id": 92,
        "name": "Holanda",
        "initials2": "NL",
        "initials3": "NLD",
        "code": "528"
    },
    {
        "id": 93,
        "name": "Honduras",
        "initials2": "HN",
        "initials3": "HND",
        "code": "340"
    },
    {
        "id": 94,
        "name": "Hong Kong",
        "initials2": "HK",
        "initials3": "HKG",
        "code": "344"
    },
    {
        "id": 95,
        "name": "Hungria",
        "initials2": "HU",
        "initials3": "HUN",
        "code": "348"
    },
    {
        "id": 96,
        "name": "Iêmen",
        "initials2": "YE",
        "initials3": "YEM",
        "code": "887"
    },
    {
        "id": 97,
        "name": "Ilha Bouvet (Território da Noruega)",
        "initials2": "BV",
        "initials3": "BVT",
        "code": "074"
    },
    {
        "id": 98,
        "name": "Ilha do Homem",
        "initials2": "IM",
        "initials3": "IMN",
        "code": "833"
    },
    {
        "id": 99,
        "name": "Ilha Natal",
        "initials2": "CX",
        "initials3": "CXR",
        "code": "162"
    },
    {
        "id": 100,
        "name": "Ilha Pitcairn",
        "initials2": "PN",
        "initials3": "PCN",
        "code": "612"
    },
    {
        "id": 101,
        "name": "Ilha Reunião",
        "initials2": "RE",
        "initials3": "REU",
        "code": "638"
    },
    {
        "id": 102,
        "name": "Ilhas Aland",
        "initials2": "AX",
        "initials3": "ALA",
        "code": "248"
    },
    {
        "id": 103,
        "name": "Ilhas Cayman",
        "initials2": "KY",
        "initials3": "CYM",
        "code": "136"
    },
    {
        "id": 104,
        "name": "Ilhas Cocos",
        "initials2": "CC",
        "initials3": "CCK",
        "code": "166"
    },
    {
        "id": 105,
        "name": "Ilhas Comores",
        "initials2": "KM",
        "initials3": "COM",
        "code": "174"
    },
    {
        "id": 106,
        "name": "Ilhas Cook",
        "initials2": "CK",
        "initials3": "COK",
        "code": "184"
    },
    {
        "id": 107,
        "name": "Ilhas Faroes",
        "initials2": "FO",
        "initials3": "FRO",
        "code": "234"
    },
    {
        "id": 108,
        "name": "Ilhas Falkland (Malvinas)",
        "initials2": "FK",
        "initials3": "FLK",
        "code": "238"
    },
    {
        "id": 109,
        "name": "Ilhas Geórgia do Sul e Sandwich do Sul",
        "initials2": "GS",
        "initials3": "SGS",
        "code": "239"
    },
    {
        "id": 110,
        "name": "Ilhas Heard e McDonald (Território da Austrália)",
        "initials2": "HM",
        "initials3": "HMD",
        "code": "334"
    },
    {
        "id": 111,
        "name": "Ilhas Marianas do Norte",
        "initials2": "MP",
        "initials3": "MNP",
        "code": "580"
    },
    {
        "id": 112,
        "name": "Ilhas Marshall",
        "initials2": "MH",
        "initials3": "MHL",
        "code": "584"
    },
    {
        "id": 113,
        "name": "Ilhas Menores dos Estados Unidos",
        "initials2": "UM",
        "initials3": "UMI",
        "code": "581"
    },
    {
        "id": 114,
        "name": "Ilhas Norfolk",
        "initials2": "NF",
        "initials3": "NFK",
        "code": "574"
    },
    {
        "id": 115,
        "name": "Ilhas Seychelles",
        "initials2": "SC",
        "initials3": "SYC",
        "code": "690"
    },
    {
        "id": 116,
        "name": "Ilhas Solomão",
        "initials2": "SB",
        "initials3": "SLB",
        "code": "090"
    },
    {
        "id": 117,
        "name": "Ilhas Svalbard e Jan Mayen",
        "initials2": "SJ",
        "initials3": "SJM",
        "code": "744"
    },
    {
        "id": 118,
        "name": "Ilhas Tokelau",
        "initials2": "TK",
        "initials3": "TKL",
        "code": "772"
    },
    {
        "id": 119,
        "name": "Ilhas Turks e Caicos",
        "initials2": "TC",
        "initials3": "TCA",
        "code": "796"
    },
    {
        "id": 120,
        "name": "Ilhas Virgens (Estados Unidos)",
        "initials2": "VI",
        "initials3": "VIR",
        "code": "850"
    },
    {
        "id": 121,
        "name": "Ilhas Virgens (Inglaterra)",
        "initials2": "VG",
        "initials3": "VGB",
        "code": "092"
    },
    {
        "id": 122,
        "name": "Ilhas Wallis e Futuna",
        "initials2": "WF",
        "initials3": "WLF",
        "code": "876"
    },
    {
        "id": 123,
        "name": "índia",
        "initials2": "IN",
        "initials3": "IND",
        "code": "356"
    },
    {
        "id": 124,
        "name": "Indonésia",
        "initials2": "ID",
        "initials3": "IDN",
        "code": "360"
    },
    {
        "id": 125,
        "name": "Irã",
        "initials2": "IR",
        "initials3": "IRN",
        "code": "364"
    },
    {
        "id": 126,
        "name": "Iraque",
        "initials2": "IQ",
        "initials3": "IRQ",
        "code": "368"
    },
    {
        "id": 127,
        "name": "Irlanda",
        "initials2": "IE",
        "initials3": "IRL",
        "code": "372"
    },
    {
        "id": 128,
        "name": "Islândia",
        "initials2": "IS",
        "initials3": "ISL",
        "code": "352"
    },
    {
        "id": 129,
        "name": "Israel",
        "initials2": "IL",
        "initials3": "ISR",
        "code": "376"
    },
    {
        "id": 130,
        "name": "Itália",
        "initials2": "IT",
        "initials3": "ITA",
        "code": "380"
    },
    {
        "id": 131,
        "name": "Jamaica",
        "initials2": "JM",
        "initials3": "JAM",
        "code": "388"
    },
    {
        "id": 132,
        "name": "Japão",
        "initials2": "JP",
        "initials3": "JPN",
        "code": "392"
    },
    {
        "id": 133,
        "name": "Jersey",
        "initials2": "JE",
        "initials3": "JEY",
        "code": "832"
    },
    {
        "id": 134,
        "name": "Jordânia",
        "initials2": "JO",
        "initials3": "JOR",
        "code": "400"
    },
    {
        "id": 135,
        "name": "Kênia",
        "initials2": "KE",
        "initials3": "KEN",
        "code": "404"
    },
    {
        "id": 136,
        "name": "Kiribati",
        "initials2": "KI",
        "initials3": "KIR",
        "code": "296"
    },
    {
        "id": 137,
        "name": "Kuait",
        "initials2": "KW",
        "initials3": "KWT",
        "code": "414"
    },
    {
        "id": 138,
        "name": "Laos",
        "initials2": "LA",
        "initials3": "LAO",
        "code": "418"
    },
    {
        "id": 139,
        "name": "Látvia",
        "initials2": "LV",
        "initials3": "LVA",
        "code": "428"
    },
    {
        "id": 140,
        "name": "Lesoto",
        "initials2": "LS",
        "initials3": "LSO",
        "code": "426"
    },
    {
        "id": 141,
        "name": "Líbano",
        "initials2": "LB",
        "initials3": "LBN",
        "code": "422"
    },
    {
        "id": 142,
        "name": "Libéria",
        "initials2": "LR",
        "initials3": "LBR",
        "code": "430"
    },
    {
        "id": 143,
        "name": "Líbia",
        "initials2": "LY",
        "initials3": "LBY",
        "code": "434"
    },
    {
        "id": 144,
        "name": "Liechtenstein",
        "initials2": "LI",
        "initials3": "LIE",
        "code": "438"
    },
    {
        "id": 145,
        "name": "Lituânia",
        "initials2": "LT",
        "initials3": "LTU",
        "code": "440"
    },
    {
        "id": 146,
        "name": "Luxemburgo",
        "initials2": "LU",
        "initials3": "LUX",
        "code": "442"
    },
    {
        "id": 147,
        "name": "Macau",
        "initials2": "MO",
        "initials3": "MAC",
        "code": "446"
    },
    {
        "id": 148,
        "name": "Macedônia (República Yugoslava)",
        "initials2": "MK",
        "initials3": "MKD",
        "code": "807"
    },
    {
        "id": 149,
        "name": "Madagascar",
        "initials2": "MG",
        "initials3": "MDG",
        "code": "450"
    },
    {
        "id": 150,
        "name": "Malásia",
        "initials2": "MY",
        "initials3": "MYS",
        "code": "458"
    },
    {
        "id": 151,
        "name": "Malaui",
        "initials2": "MW",
        "initials3": "MWI",
        "code": "454"
    },
    {
        "id": 152,
        "name": "Maldivas",
        "initials2": "MV",
        "initials3": "MDV",
        "code": "462"
    },
    {
        "id": 153,
        "name": "Mali",
        "initials2": "ML",
        "initials3": "MLI",
        "code": "466"
    },
    {
        "id": 154,
        "name": "Malta",
        "initials2": "MT",
        "initials3": "MLT",
        "code": "470"
    },
    {
        "id": 155,
        "name": "Marrocos",
        "initials2": "MA",
        "initials3": "MAR",
        "code": "504"
    },
    {
        "id": 156,
        "name": "Martinica",
        "initials2": "MQ",
        "initials3": "MTQ",
        "code": "474"
    },
    {
        "id": 157,
        "name": "Maurício",
        "initials2": "MU",
        "initials3": "MUS",
        "code": "480"
    },
    {
        "id": 158,
        "name": "Mauritânia",
        "initials2": "MR",
        "initials3": "MRT",
        "code": "478"
    },
    {
        "id": 159,
        "name": "Mayotte",
        "initials2": "YT",
        "initials3": "MYT",
        "code": "175"
    },
    {
        "id": 160,
        "name": "México",
        "initials2": "MX",
        "initials3": "MEX",
        "code": "484"
    },
    {
        "id": 161,
        "name": "Micronésia",
        "initials2": "FM",
        "initials3": "FSM",
        "code": "583"
    },
    {
        "id": 162,
        "name": "Moçambique",
        "initials2": "MZ",
        "initials3": "MOZ",
        "code": "508"
    },
    {
        "id": 163,
        "name": "Moldova",
        "initials2": "MD",
        "initials3": "MDA",
        "code": "498"
    },
    {
        "id": 164,
        "name": "Mônaco",
        "initials2": "MC",
        "initials3": "MCO",
        "code": "492"
    },
    {
        "id": 165,
        "name": "Mongólia",
        "initials2": "MN",
        "initials3": "MNG",
        "code": "496"
    },
    {
        "id": 166,
        "name": "Montenegro",
        "initials2": "ME",
        "initials3": "MNE",
        "code": "499"
    },
    {
        "id": 167,
        "name": "Montserrat",
        "initials2": "MS",
        "initials3": "MSR",
        "code": "500"
    },
    {
        "id": 168,
        "name": "Myanma",
        "initials2": "MM",
        "initials3": "MMR",
        "code": "104"
    },
    {
        "id": 169,
        "name": "Namíbia",
        "initials2": "NA",
        "initials3": "NAM",
        "code": "516"
    },
    {
        "id": 170,
        "name": "Nauru",
        "initials2": "NR",
        "initials3": "NRU",
        "code": "520"
    },
    {
        "id": 171,
        "name": "Nepal",
        "initials2": "NP",
        "initials3": "NPL",
        "code": "524"
    },
    {
        "id": 172,
        "name": "Nicarágua",
        "initials2": "NI",
        "initials3": "NIC",
        "code": "558"
    },
    {
        "id": 173,
        "name": "Níger",
        "initials2": "NE",
        "initials3": "NER",
        "code": "562"
    },
    {
        "id": 174,
        "name": "Nigéria",
        "initials2": "NG",
        "initials3": "NGA",
        "code": "566"
    },
    {
        "id": 175,
        "name": "Niue",
        "initials2": "NU",
        "initials3": "NIU",
        "code": "570"
    },
    {
        "id": 176,
        "name": "Noruega",
        "initials2": "NO",
        "initials3": "NOR",
        "code": "578"
    },
    {
        "id": 177,
        "name": "Nova Caledônia",
        "initials2": "NC",
        "initials3": "NCL",
        "code": "540"
    },
    {
        "id": 178,
        "name": "Nova Zelândia",
        "initials2": "NZ",
        "initials3": "NZL",
        "code": "554"
    },
    {
        "id": 179,
        "name": "Omã",
        "initials2": "OM",
        "initials3": "OMN",
        "code": "512"
    },
    {
        "id": 180,
        "name": "Palau",
        "initials2": "PW",
        "initials3": "PLW",
        "code": "585"
    },
    {
        "id": 181,
        "name": "Panamá",
        "initials2": "PA",
        "initials3": "PAN",
        "code": "591"
    },
    {
        "id": 182,
        "name": "Papua-Nova Guiné",
        "initials2": "PG",
        "initials3": "PNG",
        "code": "598"
    },
    {
        "id": 183,
        "name": "Paquistão",
        "initials2": "PK",
        "initials3": "PAK",
        "code": "586"
    },
    {
        "id": 184,
        "name": "Paraguai",
        "initials2": "PY",
        "initials3": "PRY",
        "code": "600"
    },
    {
        "id": 185,
        "name": "Peru",
        "initials2": "PE",
        "initials3": "PER",
        "code": "604"
    },
    {
        "id": 186,
        "name": "Polinésia Francesa",
        "initials2": "PF",
        "initials3": "PYF",
        "code": "258"
    },
    {
        "id": 187,
        "name": "Polônia",
        "initials2": "PL",
        "initials3": "POL",
        "code": "616"
    },
    {
        "id": 188,
        "name": "Porto Rico",
        "initials2": "PR",
        "initials3": "PRI",
        "code": "630"
    },
    {
        "id": 189,
        "name": "Portugal",
        "initials2": "PT",
        "initials3": "PRT",
        "code": "620"
    },
    {
        "id": 190,
        "name": "Qatar",
        "initials2": "QA",
        "initials3": "QAT",
        "code": "634"
    },
    {
        "id": 191,
        "name": "Quirguistão",
        "initials2": "KG",
        "initials3": "KGZ",
        "code": "417"
    },
    {
        "id": 192,
        "name": "República Centro-Africana",
        "initials2": "CF",
        "initials3": "CAF",
        "code": "140"
    },
    {
        "id": 193,
        "name": "República Democrática do Congo",
        "initials2": "CD",
        "initials3": "COD",
        "code": "180"
    },
    {
        "id": 194,
        "name": "República Dominicana",
        "initials2": "DO",
        "initials3": "DOM",
        "code": "214"
    },
    {
        "id": 195,
        "name": "República Tcheca",
        "initials2": "CZ",
        "initials3": "CZE",
        "code": "203"
    },
    {
        "id": 196,
        "name": "Romênia",
        "initials2": "RO",
        "initials3": "ROM",
        "code": "642"
    },
    {
        "id": 197,
        "name": "Ruanda",
        "initials2": "RW",
        "initials3": "RWA",
        "code": "646"
    },
    {
        "id": 198,
        "name": "Rússia (antiga URSS) - Federação Russa",
        "initials2": "RU",
        "initials3": "RUS",
        "code": "643"
    },
    {
        "id": 199,
        "name": "Saara Ocidental",
        "initials2": "EH",
        "initials3": "ESH",
        "code": "732"
    },
    {
        "id": 200,
        "name": "Saint Vincente e Granadinas",
        "initials2": "VC",
        "initials3": "VCT",
        "code": "670"
    },
    {
        "id": 201,
        "name": "Samoa Americana",
        "initials2": "AS",
        "initials3": "ASM",
        "code": "016"
    },
    {
        "id": 202,
        "name": "Samoa Ocidental",
        "initials2": "WS",
        "initials3": "WSM",
        "code": "882"
    },
    {
        "id": 203,
        "name": "San Marino",
        "initials2": "SM",
        "initials3": "SMR",
        "code": "674"
    },
    {
        "id": 204,
        "name": "Santa Helena",
        "initials2": "SH",
        "initials3": "SHN",
        "code": "654"
    },
    {
        "id": 205,
        "name": "Santa Lúcia",
        "initials2": "LC",
        "initials3": "LCA",
        "code": "662"
    },
    {
        "id": 206,
        "name": "São Bartolomeu",
        "initials2": "BL",
        "initials3": "BLM",
        "code": "652"
    },
    {
        "id": 207,
        "name": "São Cristóvão e Névis",
        "initials2": "KN",
        "initials3": "KNA",
        "code": "659"
    },
    {
        "id": 208,
        "name": "São Martim",
        "initials2": "MF",
        "initials3": "MAF",
        "code": "663"
    },
    {
        "id": 209,
        "name": "São Tomé e Príncipe",
        "initials2": "ST",
        "initials3": "STP",
        "code": "678"
    },
    {
        "id": 210,
        "name": "Senegal",
        "initials2": "SN",
        "initials3": "SEN",
        "code": "686"
    },
    {
        "id": 211,
        "name": "Serra Leoa",
        "initials2": "SL",
        "initials3": "SLE",
        "code": "694"
    },
    {
        "id": 212,
        "name": "Sérvia",
        "initials2": "RS",
        "initials3": "SRB",
        "code": "688"
    },
    {
        "id": 213,
        "name": "Síria",
        "initials2": "SY",
        "initials3": "SYR",
        "code": "760"
    },
    {
        "id": 214,
        "name": "Somália",
        "initials2": "SO",
        "initials3": "SOM",
        "code": "706"
    },
    {
        "id": 215,
        "name": "Sri Lanka",
        "initials2": "LK",
        "initials3": "LKA",
        "code": "144"
    },
    {
        "id": 216,
        "name": "St. Pierre and Miquelon",
        "initials2": "PM",
        "initials3": "SPM",
        "code": "666"
    },
    {
        "id": 217,
        "name": "Suazilândia",
        "initials2": "SZ",
        "initials3": "SWZ",
        "code": "748"
    },
    {
        "id": 218,
        "name": "Sudão",
        "initials2": "SD",
        "initials3": "SDN",
        "code": "736"
    },
    {
        "id": 219,
        "name": "Suécia",
        "initials2": "SE",
        "initials3": "SWE",
        "code": "752"
    },
    {
        "id": 220,
        "name": "Suíça",
        "initials2": "CH",
        "initials3": "CHE",
        "code": "756"
    },
    {
        "id": 221,
        "name": "Suriname",
        "initials2": "SR",
        "initials3": "SUR",
        "code": "740"
    },
    {
        "id": 222,
        "name": "Tadjiquistão",
        "initials2": "TJ",
        "initials3": "TJK",
        "code": "762"
    },
    {
        "id": 223,
        "name": "Tailândia",
        "initials2": "TH",
        "initials3": "THA",
        "code": "764"
    },
    {
        "id": 224,
        "name": "Taiwan",
        "initials2": "TW",
        "initials3": "TWN",
        "code": "158"
    },
    {
        "id": 225,
        "name": "Tanzânia",
        "initials2": "TZ",
        "initials3": "TZA",
        "code": "834"
    },
    {
        "id": 226,
        "name": "Território Britânico do Oceano índico",
        "initials2": "IO",
        "initials3": "IOT",
        "code": "086"
    },
    {
        "id": 227,
        "name": "Territórios do Sul da França",
        "initials2": "TF",
        "initials3": "ATF",
        "code": "260"
    },
    {
        "id": 228,
        "name": "Territórios Palestinos Ocupados",
        "initials2": "PS",
        "initials3": "PSE",
        "code": "275"
    },
    {
        "id": 229,
        "name": "Timor Leste",
        "initials2": "TP",
        "initials3": "TMP",
        "code": "626"
    },
    {
        "id": 230,
        "name": "Togo",
        "initials2": "TG",
        "initials3": "TGO",
        "code": "768"
    },
    {
        "id": 231,
        "name": "Tonga",
        "initials2": "TO",
        "initials3": "TON",
        "code": "776"
    },
    {
        "id": 232,
        "name": "Trinidad and Tobago",
        "initials2": "TT",
        "initials3": "TTO",
        "code": "780"
    },
    {
        "id": 233,
        "name": "Tunísia",
        "initials2": "TN",
        "initials3": "TUN",
        "code": "788"
    },
    {
        "id": 234,
        "name": "Turcomenistão",
        "initials2": "TM",
        "initials3": "TKM",
        "code": "795"
    },
    {
        "id": 235,
        "name": "Turquia",
        "initials2": "TR",
        "initials3": "TUR",
        "code": "792"
    },
    {
        "id": 236,
        "name": "Tuvalu",
        "initials2": "TV",
        "initials3": "TUV",
        "code": "798"
    },
    {
        "id": 237,
        "name": "Ucrânia",
        "initials2": "UA",
        "initials3": "UKR",
        "code": "804"
    },
    {
        "id": 238,
        "name": "Uganda",
        "initials2": "UG",
        "initials3": "UGA",
        "code": "800"
    },
    {
        "id": 239,
        "name": "Uruguai",
        "initials2": "UY",
        "initials3": "URY",
        "code": "858"
    },
    {
        "id": 240,
        "name": "Uzbequistão",
        "initials2": "UZ",
        "initials3": "UZB",
        "code": "860"
    },
    {
        "id": 241,
        "name": "Vanuatu",
        "initials2": "VU",
        "initials3": "VUT",
        "code": "548"
    },
    {
        "id": 242,
        "name": "Vaticano",
        "initials2": "VA",
        "initials3": "VAT",
        "code": "336"
    },
    {
        "id": 243,
        "name": "Venezuela",
        "initials2": "VE",
        "initials3": "VEN",
        "code": "862"
    },
    {
        "id": 244,
        "name": "Vietnã",
        "initials2": "VN",
        "initials3": "VNM",
        "code": "704"
    },
    {
        "id": 245,
        "name": "Zâmbia",
        "initials2": "ZM",
        "initials3": "ZMB",
        "code": "894"
    },
    {
        "id": 246,
        "name": "Zimbábue",
        "initials2": "ZW",
        "initials3": "ZWE",
        "code": "716"
    }
]